import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, StaffAssignmentFilter, TagStaffRequest } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, JobOperationActions } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../Services/UserService';
import { JobOperations } from '../JobOperations/JobOperations';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'TagStaff',
    templateUrl: './TagStaff.html'
})

export class TagStaff extends BaseComponent implements OnInit {
    @ViewChild('content') content;   

    PropertyId: number;
    RequestModel: TagStaffRequest = new TagStaffRequest();

    Keyword: string = "";
    SelectedStaffId: number = null;
    ModalRef: NgbModalRef;
    @Input() SelectionMode: number = 1;

    @Output() TagStaffSelected: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();

    InData: Array<Staff_Search_Assigment>;
    Model: Array<Staff_Search_Assigment>;
    _EntityCodes = EntityCodes;
    IsSubmitting: boolean = true;
    JobData: any;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected userService: UserService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {

    }

    onKeyword(value: string): void {
        this.Keyword = value;
        this.onFilter();
    }
    
    Open(EntityId: number, EntityCode: string, PropertyId: number, JobData: any): void {
        this.ClearErrors();
        this.Keyword = null;
        this.PropertyId = PropertyId;
        this.RequestModel.EntityId = EntityId;
        this.RequestModel.EntityCode = EntityCode;
        this.SetData();

        if (JobData) {
            this.JobData = JobData;
            if (EntityCode == EntityCodes.Glitch) {
                JobData.DisplayCallNo = JobData.GlitchCallNo;
                JobData.CallDescription = JobData.Description;
            }
        }

        this.ModalRef = this.modalService.open(this.content, { size: 'lg', centered: true, backdrop:'static' });
        
    }

    onTagChange(row: Staff_Search_Assigment): void {
        let idx = this.InData.findIndex(a => a.StaffId == row.StaffId);
        if (idx >= 0) {
            let inRow: any = this.InData[idx];
            let cRow: any = row;
            inRow.Selected = cRow.Selected;
        }
    }

    onFilter(): void {
        let kw = this.Keyword;
        if (kw == null || kw.length == 0) {
            this.Model = _.cloneDeep(this.InData);
            return;
        }

        let arr = this.InData.filter(row => {
            if (row.Description != null) {
                if (row.Description.toUpperCase().indexOf(kw.toUpperCase()) >= 0)
                    return true;
            }

            if (row.Department != null) {
                if (row.Department.toUpperCase().indexOf(kw.toUpperCase()) >= 0)
                    return true;
            }

            if (row.Designation != null) {
                if (row.Designation.toUpperCase().indexOf(kw.toUpperCase()) >= 0)
                    return true;
            }

            return false;
        });

        this.Model = _.cloneDeep(arr);
    }

    onSubmit(): void {
        if (this.SelectionMode == 1) {
            this.SaveTags();
        }
        else if (this.SelectionMode == 2) {
            this.TagStaffSelected.emit(this.RequestModel.StaffIds);
        }
    }

    SaveTags(): void{
        this.ClearErrors();

        this.RequestModel.StaffIds = [];
        this.RequestModel.StaffNames = [];
        this.InData.map(a => {
            let row:any = a;
            if (row.Selected) {
                this.RequestModel.StaffIds.push(row.StaffId);
                this.RequestModel.StaffNames.push(row.Description);
            }
        })

        this.userService.TagStaff_Save(this.RequestModel).then(data => {
            if (data.HasError) {
                this.FromBaseResponse(data);
                return;
            }

            this.GetMultilingualToast("TS.TS_GENERAL_SAVED", 'success');

            this.TagStaffSelected.emit(this.RequestModel.StaffIds);
            this.ModalRef.close();
        });
    }
    
    SetData(): void {
        let req = new StaffAssignmentFilter();
        req.PropertyId = this.PropertyId;
        req.AllPropertyCallCount = false;
        req.IncluedAllstaff = true;
        this.IsSubmitting = true;
        //this.masterService.MasterData_GetMutli(row.PropertId, row.StaffId, EntityCodes.Staff, row.Designation);
        this.userService.Staff_ForAssignment(req).then(data => {
            this.onFilter();
            this.userService.TagStaff_Get(this.RequestModel.EntityId, this.RequestModel.EntityCode).then(lstStaff => {
                data.map(mr => {
                    let row: any = mr;
                    let idx = lstStaff.findIndex(a => a == row.StaffId);
                    row.Selected = (idx >= 0);
                });

                this.Model = data;
                this.InData = _.cloneDeep(data);
                this.IsSubmitting = false;
            })
        })
    }
    SortData(): void {
        let Data: any = _.cloneDeep(this.Model)
        let idx = Data.findIndex(a => a.Selected == true);
        if (idx >= 0) {
            Data.sort(function (a, b) {
                return (a.Selected === b.Selected) ? 0 : a.Selected ? -1 : 1;
            });
            this.Model = Data;
            let vs = document.getElementById('virtualScroll')
            vs.scrollTop = 0;
        }
    }
}
